module.exports = "<a ui-sref=\"nominas.cargaNominaAsalariados()\">\r\n  <app-launcher color=\"#76FF03\">\r\n    <icon>Cn</icon>\r\n    <label>Carga de nómina Asimilados</label>\r\n  </app-launcher>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/carganominaasalariados/components/launcher/template.html
// module id = 852
// module chunks = 0